import React, { useState, useEffect } from "react";
import "../assets/css/styles.css";
import "../assets/css/icons.css";
import logo from "../assets/images/logo.png";
import "../assets/js/main";
import "../assets/libs/node-waves/waves.min.css";
import { Link } from "react-router-dom";

const Footer = ({ data }) => {
  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
        const defaultLang = process.env.REACT_APP_LANG;
    const lang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (lang) {
      import(`../lang/general/${lang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

/*   const { platform } = data[0];
  const { email } = platform.contact;
  const phoneNumber = platform.contact.phone[0]?.number || ""; */

  const socialIcons = {
    facebook: "ri-facebook-line",
    X: "ri-twitter-line",
    instagram: "ri-instagram-line",
    youtube: "ri-youtube-line",
  };

  return (
    <>
      <section className="mt-auto section landing-footer text-fixed-white text-start">
        <div className="container">
          <div className="row">
            <div className="col-xl-4">
              <div className="px-4">
                <ul className="list-unstyled op-6 fw-normal landing-footer-list">
                  <li>
                    <img src={logo} alt="Logo" />
                  </li>
                  <li className="mt-2">
                    <p className="mb-2 op-6 fw-normal text-black">
                      {languageData.body.footer.description}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="px-4">
                <h6 className="fw-semibold text-dark">
                  {languageData.body.footer.pages}
                </h6>
                <ul className="list-unstyled op-6 fw-normal landing-footer-list">
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_URL}faq`}
                      className="text-fixed-black"
                    >
                      {languageData.body.footer.faq}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_URL}terms`}
                      className="text-fixed-black"
                    >
                      {languageData.body.footer.terms}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_URL}privacy`}
                      className="text-fixed-black"
                    >
                      {languageData.body.footer.privacy}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="px-4">
                <h6 className="fw-semibold text-dark">
                  {languageData.body.footer.help}
                </h6>
                <ul className="list-unstyled fw-normal landing-footer-list">
                  <li>
                    <a
                      // href={platform.contact.email}
                      className="text-fixed-dark op-6"
                    >
                      <i className="ri-mail-line me-1 align-middle"></i>{" "}
                      {languageData.body.footer.contact_mail}
                    </a>
                  </li>
                  <li>
                    <a
                      // href={platform.contact.phone[0].number}
                      className="text-fixed-dark op-6"
                    >
                      <i className="ri-phone-line me-1 align-middle"></i>{" "}
                      {languageData.body.footer.contact_phone}{" "}
                      {/* {data[0].platform.name} */}
                    </a>
                  </li>
                </ul>
                <ul className="list-unstyled op-6 fw-normal landing-footer-list">
                  <li className="mt-3">
                    <div className="mb-0">
                      <div className="btn-list">
                       {/*  {platform.social.map(
                          (social, index) =>
                            social.url && (
                              <a
                                key={index}
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-icon btn-light btn-wave waves-effect waves-light"
                              >
                                <i
                                  className={`${socialIcons[social.type]} fw-bold`}
                                ></i>
                              </a>
                            ),
                        )} */}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer  py-3 bg-white text-center">
        <div className="container">
          <span className="text-muted">
            {languageData.body.footer.copyright} {new Date().getFullYear()}{" "}
            <a href="javascript:void(0);" className="text-dark fw-semibold">
           {/*    {platform.name} */}
            </a>
            . {languageData.body.footer.designed}{" "}
            <span className="bi bi-heart-fill text-danger"></span>{" "}
            {languageData.body.footer.by}{" "}
            <a href="javascript:void(0);">
              <span className="fw-semibold text-primary text-decoration-underline">
                ITwise
              </span>
            </a>{" "}
            {languageData.body.footer.rights}
          </span>
        </div>
      </footer>
    </>
  );
};

export default Footer;
